'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.defaultProps = exports.propTypes = undefined;

var _collapse_props = require('../config/collapse_props');

var _collapse_props2 = _interopRequireDefault(_collapse_props);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 根据props的data分出propsTypes与defaultProps
var key = '',
    _propTypes = {},
    _defaultProps = {}; /**
                         * @fileoverview 兼容参数
                         */


for (key in _collapse_props2.default) {
    if (_collapse_props2.default[key]) {
        if (typeof _collapse_props2.default[key].type !== 'undefined') {
            _propTypes[key] = _collapse_props2.default[key].type;
        }
        if (typeof _collapse_props2.default[key].defaultValue !== 'undefined') {
            _defaultProps[key] = _collapse_props2.default[key].defaultValue;
        }
    }
}

// 组件propTypes
var propTypes = exports.propTypes = _propTypes;
var defaultProps = exports.defaultProps = _defaultProps;

exports.default = {
    propTypes: propTypes,
    defaultProps: defaultProps
};